import { ref } from "vue"

// split out of components/Attachments.js, which is now three `.vue` files: a `<script setup>` block
// runs per instance and cannot carry a module-level composable alongside the component
export const useAttachments = () => {
  const attachments = ref([])

  const addAttachment = (attachment) => {
    if (attachment) {
      attachments.value.push(attachment)
    }
  }

  const deleteAttachment = (id) => {
    const index = attachments.value.findIndex((a) => a.id === id)
    if (index !== -1) {
      console.log("Deleting attachment", id)
      // let's add  a flage to mark the attachment as deleted
      attachments.value[index].isForDelete = true
    } else {
      console.warn("Attachment not found for deletion", id)
    }
  }

  return {
    attachments,
    addAttachment,
    deleteAttachment,
  }
}
